var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { LiTag, SpanTag, ImgTag } from '../../Utils/AtomicTag';
import classNames from 'classnames';
var Star = /** @class */ (function (_super) {
    __extends(Star, _super);
    function Star(props) {
        var _this = _super.call(this, props) || this;
        _this.onHover = function (e) {
            var _a = _this.props, onHover = _a.onHover, index = _a.index;
            onHover(e, index);
        };
        _this.onClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, index = _a.index;
            onClick(e, index);
        };
        _this.getClassName = function () {
            var _a = _this.props, index = _a.index, value = _a.value, allowHalf = _a.allowHalf, focused = _a.focused;
            var starValue = index + 1;
            var className = "star";
            if (value === 0 && index === 0 && focused) {
                className += " star-focused";
            }
            else if ((allowHalf && value + 0.5 === starValue) ||
                (starValue - 0.5 < value && value < starValue)) {
                className += " star-half star-active";
                if (focused) {
                    className += " star-focused";
                }
            }
            else {
                className += starValue <= value ? " star-full" : " star-zero";
                if (starValue === value && focused) {
                    className += " star-focused";
                }
            }
            if (_this.src) {
                _this.setSrc(className);
            }
            return className;
        };
        _this.setSrc = function (className) {
            var _a = _this.props, checkedIcon = _a.checkedIcon, uncheckedIcon = _a.uncheckedIcon;
            if (className.indexOf("star-full") > -1) {
                _this.src = checkedIcon;
            }
            else {
                _this.src = uncheckedIcon;
            }
        };
        _this.renderStar = function (setLiCls) {
            var _a;
            var _b = _this.props, character = _b.character, type = _b.type, checkedIcon = _b.checkedIcon;
            var fCls = [
                'absolute',
                'left-0',
                'top-0',
                'inline-block',
                'w-1/2',
                'h-full',
                'overflow-hidden',
                'opacity-0',
            ];
            var isFull = setLiCls.indexOf('full') > -1;
            var isHalf = setLiCls.indexOf('half') > -1;
            var sCls = [
                'inline-block',
                'w-px-18',
                'h-full',
                'opacity-100',
                'text-gray-400',
            ];
            var setFCls = isHalf
                ? ['opacity-100', 'text-warn-900']
                : [];
            var setSCls = classNames((_a = {},
                _a['opacity-0'] = isHalf,
                _a['text-warn-900'] = isFull,
                _a));
            return (React.createElement(React.Fragment, null,
                React.createElement(SpanTag, { atomics: __spread(fCls, setFCls), className: "star-first" }, type === 'font' ? character : React.createElement(ImgTag, { src: checkedIcon, atomics: "max-w-px-18" })),
                React.createElement(SpanTag, { atomics: __spread(sCls, [setSCls]), className: "star-second" }, type === 'font' ? character : React.createElement(ImgTag, { src: _this.src, atomics: "max-w-px-18" }))));
        };
        _this.src = props.uncheckedIcon;
        return _this;
    }
    Star.prototype.render = function () {
        var _a;
        var _b = this, onHover = _b.onHover, onClick = _b.onClick;
        var _c = this.props, disabled = _c.disabled, characterRender = _c.characterRender, index = _c.index, count = _c.count, value = _c.value;
        var liCls = [
            'relative',
            'inline-block',
            'align-top',
            'max-w-px-18',
            'h-px-18',
            'leading-px-18',
            'transform',
            'text-lg',
        ];
        var getLiCls = this.getClassName();
        var setLiClassName = classNames(getLiCls, (_a = {},
            _a['ml-2'] = index > 0,
            _a['cursor-pointer hover:scale-110'] = !disabled,
            _a));
        var setLiCls = setLiClassName.split(/\s/g);
        var start = (React.createElement(LiTag, { atomics: __spread(liCls, setLiCls), onClick: disabled ? undefined : onClick, onMouseMove: disabled ? undefined : onHover, role: "radio", "aria-checked": value > index ? 'true' : 'false', "aria-posinset": index + 1, "aria-setsize": count, tabIndex: 0 }, this.renderStar(getLiCls)));
        if (characterRender) {
            start = characterRender(start, this.props);
        }
        return start;
    };
    return Star;
}(PureComponent));
export { Star };
